// Module
var code = "<fieldset class=\"form flex-item flex-item-grow\" data-bind=\"scrollable: {}\">\r\n    <b>Coming soon</b>\r\n    <p>\r\n        An editor for this widget is not yet ready.<br>\r\n    </p>\r\n</fieldset>";
// Exports
export default code;